/* Shelf Reliance theme · theme.js */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideo() {
    document.querySelectorAll('video[data-autoplay]').forEach(function (v) {
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
      var go = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      v.addEventListener('canplay', go, { once: true });
      go();
    });
  }

  function initSwatches() {
    document.querySelectorAll('.swatches').forEach(function (group) {
      group.addEventListener('click', function (e) {
        if (!e.target.classList.contains('swatch')) return;
        group.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('on'); });
        e.target.classList.add('on');
      });
    });
  }

  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    var mainImg = root.querySelector('[data-main-image]');

    root.querySelectorAll('.pdp-thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.getAttribute('data-full') || t.src;
        root.querySelectorAll('.pdp-thumbs img').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });

    var variants = [];
    var dataEl = document.querySelector('[data-variants]');
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }

    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-group]'))
      .sort(function (a, b) { return (+a.dataset.optionIndex) - (+b.dataset.optionIndex); });

    var idField = root.querySelector('[name="id"]');
    var priceValue = root.querySelector('[data-price-value]');
    var addBtn = root.querySelector('[data-add]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    function chosen() {
      return groups.map(function (g) {
        var on = g.querySelector('.opt-chip.on');
        return on ? on.dataset.value : null;
      });
    }
    function currentVariant() {
      var c = chosen();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === c[i]; });
      });
    }
    function update() {
      var v = currentVariant();
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceValue) priceValue.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (v.image && mainImg) { mainImg.src = v.image; }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.innerHTML = v.available
          ? 'Add to cart &nbsp;&#8226;&nbsp; <span data-add-price>' + v.price + '</span>'
          : 'Sold out';
      }
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var chip = e.target.closest('.opt-chip');
        if (!chip) return;
        g.querySelectorAll('.opt-chip').forEach(function (c) { c.classList.remove('on'); });
        chip.classList.add('on');
        var label = g.querySelector('[data-opt-current]');
        if (label) label.textContent = chip.dataset.value;
        update();
      });
    });

    var qty = root.querySelector('[data-qty-input]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    update();
  }

  function initSticky() {
    var bar = document.querySelector('[data-sticky-bar]');
    var addBtn = document.querySelector('.pdp-add');
    var form = document.querySelector('[data-add-form]');
    if (!bar || !addBtn || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { bar.hidden = true; }
        else if (en.boundingClientRect.top < 0) { bar.hidden = false; }
      });
    }, { threshold: 0 });
    io.observe(addBtn);

    var stickyAdd = bar.querySelector('[data-sticky-add]');
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }

  function initCartCount() {
    var badge = document.querySelector('.cart-count');
    if (!badge) return;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-add-form]')) return;
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { badge.textContent = cart.item_count; })
        .catch(function () { form.submit(); });
    });
  }

  /* Collection: sort auto-submit + mobile filter drawer */
  function initCollection() {
    var sort = document.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var form = sort.closest('form');
        if (form) form.submit();
      });
    }

    var aside = document.querySelector('[data-filters]');
    var openBtn = document.querySelector('[data-filter-open]');
    var closeBtn = document.querySelector('[data-filter-close]');
    if (!aside || !openBtn) return;
    var backdrop;
    function open() {
      aside.classList.add('open');
      backdrop = document.createElement('div');
      backdrop.className = 'filters-backdrop';
      backdrop.addEventListener('click', close);
      document.body.appendChild(backdrop);
      document.body.style.overflow = 'hidden';
    }
    function close() {
      aside.classList.remove('open');
      if (backdrop) { backdrop.remove(); backdrop = null; }
      document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  /* Cart page: live quantity + remove via Section Rendering API */
  function initCart() {
    var root = document.querySelector('[data-cart]');
    if (!root) return;

    function change(key, qty, node) {
      root.classList.add('cart-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: 'main', sections_url: '/cart' })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badge = document.querySelector('.cart-count');
          if (badge) badge.textContent = cart.item_count;
          if (cart.sections && cart.sections.main) {
            var tmp = document.createElement('div');
            tmp.innerHTML = cart.sections.main;
            var fresh = tmp.querySelector('[data-cart]');
            if (fresh) { root.replaceWith(fresh); initCart(); return; }
          }
          window.location.href = '/cart';
        })
        .catch(function () { window.location.href = '/cart'; });
    }

    root.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var remove = e.target.closest('[data-remove]');
      if ((minus || plus) && line) {
        var input = line.querySelector('[data-qty-input]');
        var q = parseInt(input.value, 10) || 1;
        q = plus ? q + 1 : Math.max(0, q - 1);
        input.value = q;
        change(line.dataset.key, q, line);
      }
      if (remove && line) { e.preventDefault(); change(line.dataset.key, 0, line); }
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      var line = e.target.closest('.cart-line');
      if (input && line) { change(line.dataset.key, Math.max(0, parseInt(input.value, 10) || 0), line); }
    });
  }

  /* Account: recover-password toggle + address forms */
  function initAccount() {
    var loginView = document.getElementById('login-view');
    var recoverView = document.getElementById('recover-view');
    if (loginView && recoverView) {
      var show = function (recover) {
        loginView.hidden = recover;
        recoverView.hidden = !recover;
      };
      document.querySelectorAll('[data-recover-open]').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); show(true); });
      });
      document.querySelectorAll('[data-recover-close]').forEach(function (el) {
        el.addEventListener('click', function (e) { e.preventDefault(); show(false); });
      });
      if (window.location.hash === '#recover') show(true);
    }

    var addr = document.querySelector('[data-addresses]');
    if (!addr) return;
    var newForm = addr.querySelector('[data-new-form]');
    addr.querySelector('[data-new-toggle]') && addr.querySelector('[data-new-toggle]').addEventListener('click', function () { if (newForm) newForm.hidden = false; });
    addr.querySelector('[data-new-cancel]') && addr.querySelector('[data-new-cancel]').addEventListener('click', function () { if (newForm) newForm.hidden = true; });
    addr.querySelectorAll('[data-edit-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = addr.querySelector('[data-edit-form="' + btn.getAttribute('data-edit-toggle') + '"]');
        if (f) f.hidden = !f.hidden;
      });
    });
    addr.querySelectorAll('[data-edit-cancel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = addr.querySelector('[data-edit-form="' + btn.getAttribute('data-edit-cancel') + '"]');
        if (f) f.hidden = true;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideo(); initSwatches(); initProduct(); initSticky(); initCollection(); initCart(); initAccount(); initCartCount();
  });
})();
